<template>
    <div class="mx-2 search-wrapper" id="focusableDiv">
        <v-text-field v-model="searchQuery" autocomplete="off" rounded="lg" clearable variant="outlined" hide-details theme="light"
            single-line prepend-inner-icon="$search" label="Search" density="compact"
            class="search-field" />
        <span v-if="showResults" class="results" rounded>
            <search-results :search-query="searchQuery.trim()" />
        </span>
    </div>
</template>

<script>
import eventBus from "../eventBus";
import SearchResults from "./SearchResults.vue";

export default {
    data() {
        return {
            searchQuery: "",
        };
    },
    components: {
        SearchResults,
    },
    computed: {
        showResults() {
            if (
                this.searchQuery == null ||
                this.searchQuery == undefined ||
                this.searchQuery == ""
            ) {
                return false;
            }

            return this.searchQuery.trim().length > 0;
        },
    },
    mounted() {
        this._onClearSearchResults = () => {
            this.searchQuery = "";
        };
        eventBus.on("CLEAR_SEARCH_RESULTS", this._onClearSearchResults);

        this._onDocumentClick = (evt) => {
            const flyOutElement = document.getElementById("focusableDiv");
            let targetElement = evt.target;

            do {
                if (targetElement == flyOutElement) {
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);

            this.searchQuery = "";
        };
        document.addEventListener("click", this._onDocumentClick);
    },
    beforeUnmount() {
        eventBus.off("CLEAR_SEARCH_RESULTS", this._onClearSearchResults);
        document.removeEventListener("click", this._onDocumentClick);
    },
};
</script>

<style>
.search-wrapper {
    position: relative;
    width: 350px;
    max-width: 100%;
}

.v-theme--dark .search-field .v-field {
    background-color: rgb(45, 45, 45);
}

.v-theme--light .search-field .v-field {
    background-color: rgb(242, 242, 241);
}

.search-field .v-field__outline {
    --v-field-border-opacity: 1;
    --v-field-border-width: 1px;
}

.search-field .v-field--focused .v-field__outline {
    --v-field-border-width: 1px;
}

.v-theme--dark .search-field .v-field__outline {
    color: rgb(138, 138, 135);
}

.v-theme--dark .search-field .v-field:hover .v-field__outline {
    color: rgb(166, 166, 162);
}

.v-theme--light .search-field .v-field__outline {
    color: rgb(217, 217, 214);
}

.v-theme--light .search-field .v-field:hover .v-field__outline {
    color: rgb(184, 184, 180);
}

.results {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1;
}
</style>
